import { formatPhoneNumber, extractPhoneNumber } from "@/app/_module/utils/formatters";

export const handlePhoneKeyDown = (
  e: React.KeyboardEvent<HTMLInputElement>
) => {
  // Allow: backspace, delete, tab, escape, enter, home, end, left, right arrows
  if (
    [
      "Backspace",
      "Tab",
      "Escape",
      "Enter",
      "Delete",
      "Home",
      "End",
      "ArrowLeft",
      "ArrowRight",
    ].includes(e.key) ||
    // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X (Windows/Linux)
    (e.key === "a" && e.ctrlKey) ||
    (e.key === "c" && e.ctrlKey) ||
    (e.key === "v" && e.ctrlKey) ||
    (e.key === "x" && e.ctrlKey) ||
    // Allow Cmd+A, Cmd+C, Cmd+V, Cmd+X (Mac)
    (e.key === "a" && e.metaKey) ||
    (e.key === "c" && e.metaKey) ||
    (e.key === "v" && e.metaKey) ||
    (e.key === "x" && e.metaKey)
  ) {
    return;
  }

  // Only allow digits for US phone numbers
  if (
    (e.key < "0" || e.key > "9") &&
    (e.key < "Numpad0" || e.key > "Numpad9")
  ) {
    e.preventDefault();
  }
};

/**
 * Handles onChange events for phone input fields with automatic formatting
 */
export const handlePhoneChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  onChange: (value: string) => void
) => {
  const formatted = formatPhoneNumber(e.target.value);
  onChange(formatted);
};

/**
 * Custom hook for phone input handling
 * Returns both formatted value for display and raw value for storage
 */
export const usePhoneInput = (onChange: (value: string) => void) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handlePhoneChange(e, onChange);
  };

  return {
    onKeyDown: handlePhoneKeyDown,
    onChange: handleChange,
  };
};

/**
 * Hook that provides formatted display value but stores raw value
 */
export const usePhoneInputWithStorage = (onChange: (value: string) => void) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhoneNumber(e.target.value);
    const raw = extractPhoneNumber(formatted);
    onChange(raw); // Store raw 10-digit number
  };

  return {
    onKeyDown: handlePhoneKeyDown,
    onChange: handleChange,
  };
};
